export default "__VITE_ASSET__DJDoDRNn__"